module.exports = __webpack_public_path__ + "static/anise-b316b0631ea0b00ac61237cb81309cc3.svg";